import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 bg-navy text-center" data-id="element-129" data-mp="32wd2qgad7ltj">
      <p className="text-sm font-serif font-bold text-white" data-id="element-130" data-mp="3gfsoqi9xf4pm">
        Swim Instructor Ready
        <span className="text-gold-light" data-id="element-131" data-mp="32oe3s5wgktfx"> — Complete 6-in-1 Teaching System</span>
      </p>
      <p className="text-xs text-white/60 mt-2" data-id="element-132" data-mp="36p6buvtlgsam">
        © Swim Instructor Ready 2026 — All Rights Reserved. Digital teaching material for
        swim instructors. Results depend on how the system is applied at the pool.
      </p>
    </footer>;
}